<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">在线签名支付</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <img style="height: 3em;" src="/static/img/WePayLogo.png">
          <p></p>
          <div>
            <div id="qrcode" style="display: none"></div>
            <span class="qrcode" title>
              <img style="height:10em" alt="Scan me!" src>
            </span>
          </div>
          <div class="modal-group">
            <button class="btn btn-outline-primary" @click="giveUp">放弃购买</button>
            <button class="btn btn-primary" @click="buySuccess">购买成功，马上查看</button>
          </div>
        </div>
        <div class="modal-footer">
          <p style="color:#F76C24">支付成功后，在签名管理页面核查 如有疑问联系客服：2449450354</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
import "assets/js/jquery.qrcode.min";
export default {
  props: ["pay_link", "pay_link"],
  mounted() {
    self = this;
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("showModal", false);
      });
      console.log(this.pay_link);
      var qrcode = jQuery("#qrcode").qrcode(this.pay_link);
      var canvas = qrcode.find("canvas").get(0);
      $(".qrcode img").attr("src", canvas.toDataURL("image/jpg"));
    });
  },
  methods: {
    giveUp: function() {
      $("#app_info_modal").modal("hide");
    },
    buySuccess: function() {
      this.$router.push("/sign/manager");
      $("#app_info_modal").modal("hide");
    }
  }
};
</script>

<style scoped>
.modal-group {
  padding: 20px 0;
}
.modal-group .btn {
  font-size: 14px;
  border-radius: 40px;
  min-width: 140px;
  margin: 0 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/AutoSignPayWindow.vue